import { Card, Col, Divider, Flex, Tabs } from "antd";
import styled from "styled-components";

export const SettingWrapper = styled.div`
  padding: 16px 32px;
  background-color: #f5f5f5;
  @media (max-width: 375px) {
    padding: 16px 12px;
  }
`;

export const MainSettingTitle = styled.h2`
  font-weight: 700;
  font-size: 14px;
  line-height: 16.94px;
  margin: 0;
`;

export const GeneralSettingsContainer = styled.div`
  padding: 32px 64px;

  @media (max-width: 475px) {
    padding: 32px 30px;
  }

  @media (max-width: 375px) {
    padding: 32px 18px;
  }
`;

export const PaymentSettingsContainer = styled.div`
  padding: 0px 64px;

  @media (max-width: 475px) {
    padding: 0px 30px;
  }

  @media (max-width: 375px) {
    padding: 0px 18px;
  }
`;


export const Title = styled.h3`
  font-weight: 600;
  font-weight: 600;
  font-size: 20px;
  line-height: 24.2px;
  margin: 0;
  color: #000;
`;

export const Description = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 16.94px;
  color: #9b9b9b;
`;

export const MainFormWrapper = styled.div`
  margin: 30px 0;
`;

export const CustomDivider = styled(Divider)`
  background-color: #9b9b9b;
`;

export const CustomCol = styled(Col)`
  position: relative;
`;

export const RadioWrapper = styled.div`
  margin-left: 32px;
  @media (max-width: 385px) {
    margin-left: 18px;
  }
`;

export const MainIconWrapper = styled(Flex)`
  @media (max-width: 600px) {
    flex-wrap: wrap;
    gap: 20px !important;
  }
`;

export const StyledCard = styled(Card)`
  background-color: #e6f7ff;
  border: none;
  margin-bottom: 32px;
`;

export const CustomSpan = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 16.94px;
  margin-left: 5px;
  color: #9b9b9b;
`;

export const CustomStyleDivider = styled.div`
  width: 100%;
  border-top: 1px dotted #a8a8a8;
  margin-top: 24px;
  margin-bottom: 16px;
`;

export const CustomTabs = styled(Tabs)`
  background-color: #fff;
  margin-bottom: 32px;

  .ant-card-body {
    padding-bottom: 10px !important;
    border: 1px solid #2b5582 !important;
  }

  .ant-tabs-nav-list {
    justify-content: space-between !important;
  }

  .ant-tabs-tab-btn {
    width: 100% !important;
    text-align: center !important;
  }

  .ant-tabs-nav-wrap {
    width: 100% !important;
    display: block !important;
  }

  .ant-tabs-tab {
    width: 30% !important;
    background-color: #fff !important;
    border-color: transparent !important;
    border-radius: 15px 15px 0 0 !important;
/* 
    @media (max-width: 600px) {
      width: 100% !important;
    } */

    @media (max-width: 385px) {
      padding: 8px 6px 6px !important;
    }
  }

  .ant-tabs-tab-active {
    background-color: #e6f7ff !important;
    border: 1px solid #2b5582 !important;
    border-bottom: 0px !important;
  }

  .ant-tabs-nav {
    margin-bottom: 0 !important;
  }

  .ant-input-outlined{
    background: transparent !important;
  }
`;

export const CustomLabel = styled.div`
  display: flex;
`
